import CopyContent from './CopyContent';

export default CopyContent;
